import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CONTRACT_MODAL_ACTION_TYPE } from "../../redux/actions-type";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import ContractData from "./components/ContractData";
import { getContractsAction } from "../../redux/actions/contractActions";

const ContractPage = () => {
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch({
      type: CONTRACT_MODAL_ACTION_TYPE.CONTRACT_OPEN_MODAL,
      payload: true,
    });
  };

  useEffect(() => {
    dispatch(getContractsAction());
  }, []);

  return (
    <div className="details-page courses ">
      <GlobalHead
        searchData={""}
        openModal={openModal}
        DATA_SEARCH_VALUE={""}
        dataSearchValues={""}
        profile="contracts"
        statusType={"contract"}
        count={0}
      />

      <ContractData />
    </div>
  );
};

export default ContractPage;
